/* =========================================================
   QUEED Universal Phone Mockup Engine — R2 / 738 Models
   FULL REPLACEMENT: queed-model-geometry.js

   - iPhone 16 Pro Max: existing exact Shopify template
   - Remaining models: Cloudflare R2 PNG templates
   - Missing PNG: generated camera fallback
   - No extra 738 binder required
========================================================= */

(function (window, document) {
  "use strict";

  var ENGINE_VERSION = "2.0.0-r2-738";

  var WORKER_BASE =
    "https://queed-ai-studio.queed-in42.workers.dev";

  /* =====================================================
     EXACT / MANUALLY VERIFIED MODELS
  ===================================================== */

  var EXACT = {
    "apple|iphone 16 pro max": {
      mode: "exact-image",

      template:
        "https://cdn.shopify.com/s/files/1/0600/4627/8765/files/ChatGPT_Image_Sep_17_2026_09_41_15_PM.png?v=1789661534",

      templateKey:
        "apple-iphone-16-pro-max",

      aiCrop:
        "inset(2.2% 13.8% 2.2% 13.8% round 28px)",

      aiCutout: {
        left: "13.8%",
        top: "2%",
        width: "44.5%",
        height: "30.5%",
        radius: "30px"
      },

      cartCrop:
        "inset(9% 13% 9% 13% round 14px)",

      cartCutout: {
        left: "13%",
        top: "2%",
        width: "45%",
        height: "31%",
        radius: "10px"
      }
    }
  };


  /* =====================================================
     BASIC HELPERS
  ===================================================== */

  function norm(value) {

    return String(value || "")
      .toLowerCase()
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  }


  function key(brand, model) {

    return (
      norm(brand) +
      "|" +
      norm(model)
    );

  }


  /*
    MUST MATCH THE 738 PNG FILE NAMES.

    Samsung Galaxy S24+
    ->
    samsung-galaxy-s24plus.png

    Xiaomi/Redmi
    ->
    xiaomi-redmi
  */

  function slug(value) {

    return String(value || "")
      .trim()
      .replace(/\+/g, "plus")
      .normalize("NFKD")
      .replace(
        /[\u0300-\u036f]/g,
        ""
      )
      .toLowerCase()
      .replace(
        /[^a-z0-9]+/g,
        "-"
      )
      .replace(
        /^-+|-+$/g,
        ""
      );

  }


  function r2TemplateUrl(
    brand,
    model
  ) {

    var brandSlug =
      slug(brand);

    var modelSlug =
      slug(model);


    if (
      !brandSlug ||
      !modelSlug
    ) {

      return "";

    }


    return (
      WORKER_BASE +
      "/phone-template/" +
      brandSlug +
      "/" +
      brandSlug +
      "-" +
      modelSlug +
      ".png"
    );

  }


  /* =====================================================
     PHONE FAMILY
  ===================================================== */

  function familyFor(
    brand,
    model
  ) {

    var b =
      norm(brand);

    var m =
      norm(model);


    if (
      m.indexOf("flip") !== -1 ||
      m.indexOf("razr") !== -1
    ) {

      return "flip";

    }


    if (
      m.indexOf("fold") !== -1 ||
      m.indexOf("find n") !== -1 ||
      m.indexOf("mix fold") !== -1 ||
      (
        b.indexOf("vivo") !== -1 &&
        m.indexOf("x fold") !== -1
      )
    ) {

      return "fold";

    }


    return "standard";

  }


  function cropFor(
    brand,
    model
  ) {

    var family =
      familyFor(
        brand,
        model
      );


    if (
      family === "flip"
    ) {

      return (
        "inset(" +
        "12.5% 16.3% 12.4% 16.2% " +
        "round 24px" +
        ")"
      );

    }


    if (
      family === "fold"
    ) {

      return (
        "inset(" +
        "3.8% 10.8% 3.7% 10.7% " +
        "round 24px" +
        ")"
      );

    }


    return (
      "inset(" +
      "3% 17.5% 3% 17.5% " +
      "round 28px" +
      ")"
    );

  }


  /* =====================================================
     CSS
  ===================================================== */

  function addStyles() {

    var old =
      document.getElementById(
        "queed-model-engine-styles"
      );


    if (old) {

      old.remove();

    }


    var style =
      document.createElement(
        "style"
      );


    style.id =
      "queed-model-engine-styles";


    style.textContent = `

/* =====================================
   FALLBACK CAMERA
===================================== */

.qe-camera-overlay{
  position:absolute;
  inset:0;
  z-index:70;
  pointer-events:none;
}


.qe-camera-block{
  position:absolute;

  background:
    linear-gradient(
      145deg,
      #272727,
      #090909
    );

  box-shadow:
    0 0 0 1px rgba(255,255,255,.16),
    0 4px 12px rgba(0,0,0,.25);

  overflow:visible;
}


.qe-camera-block.qe-transparent{
  background:transparent;
  box-shadow:none;
}


.qe-lens{
  position:absolute;

  border-radius:50%;

  background:
    radial-gradient(
      circle at 38% 32%,
      rgba(255,255,255,.28) 0 7%,
      transparent 8%
    ),
    radial-gradient(
      circle at center,
      #18202a 0 24%,
      #050608 27% 52%,
      #292929 55% 68%,
      #050505 71% 100%
    );

  box-shadow:
    0 0 0 1px #3d3d3d,
    0 0 0 3px #080808,
    inset 0 0 4px
    rgba(70,110,150,.32);
}


.qe-flash{
  position:absolute;

  border-radius:50%;

  background:#e8dfb6;

  box-shadow:
    0 0 0 1px
    rgba(0,0,0,.25);
}


.qe-sensor{
  position:absolute;

  border-radius:50%;

  background:#252525;

  box-shadow:
    inset 0 0 0 1px #444;
}


/* =====================================
   R2 600 × 1200 PHONE TEMPLATE
===================================== */

#queed-ai-lab
.q-phone.has-real-template.qe-r2-template{

  width:260px !important;
  height:520px !important;

  aspect-ratio:
    1 / 2 !important;

  border-radius:
    0 !important;

  background:
    transparent !important;

  box-shadow:
    none !important;

  transform:
    none !important;

  overflow:
    hidden !important;
}


#queed-ai-lab
.q-phone.has-real-template.qe-r2-template::before,

#queed-ai-lab
.q-phone.has-real-template.qe-r2-template::after{

  display:
    none !important;

  content:
    none !important;

  background:
    none !important;

  box-shadow:
    none !important;
}


#queed-ai-lab
.q-phone.has-real-template.qe-r2-template
.q-model-template{

  display:
    block !important;

  position:
    absolute !important;

  inset:
    0 !important;

  width:
    100% !important;

  height:
    100% !important;

  object-fit:
    contain !important;

  object-position:
    center !important;

  transform:
    none !important;

  z-index:
    40 !important;

  pointer-events:
    none !important;

  user-select:
    none !important;
}


#queed-ai-lab
.q-phone.has-real-template.qe-r2-template
.q-art{

  inset:
    0 !important;

  z-index:
    10 !important;

  border-radius:
    0 !important;

  overflow:
    hidden !important;

  background-color:
    transparent !important;
}


#queed-ai-lab
.q-phone.has-real-template.qe-r2-template
.q-model-cutout{

  display:
    none !important;
}


#queed-ai-lab
.q-phone.has-real-template.qe-r2-template
#q-camera{

  display:
    none !important;

  visibility:
    hidden !important;

  opacity:
    0 !important;
}


/* =====================================
   CART SUPPORT
===================================== */

.queed-cart-case.qe-r2-cart{
  position:relative;
  overflow:hidden;
}


.queed-cart-case.qe-r2-cart
.queed-cart-model-template{

  position:absolute !important;

  inset:0 !important;

  width:100% !important;

  height:100% !important;

  object-fit:
    contain !important;

  object-position:
    center !important;

  z-index:
    20 !important;

  pointer-events:
    none !important;
}


.queed-cart-case
.qe-camera-overlay{

  z-index:8;
}


/* =====================================
   MOBILE
===================================== */

@media(max-width:600px){

  #queed-ai-lab
  .q-phone.has-real-template.qe-r2-template{

    width:
      215px !important;

    height:
      430px !important;

  }

}

    `;


    document.head.appendChild(
      style
    );

  }


  /* =====================================================
     CAMERA FALLBACK DATA
  ===================================================== */

  function descFor(
    brand,
    model
  ) {

    var b =
      norm(brand);

    var m =
      norm(model);


    /* APPLE */

    if (
      b.indexOf("apple") !== -1
    ) {


      if (
        m.indexOf("se") !== -1 ||
        m.indexOf("16e") !== -1 ||
        m.indexOf("17e") !== -1
      ) {

        return {

          block: {
            left:8,
            top:4,
            width:27,
            aspect:1,
            radius:32
          },

          lenses:[
            {
              x:28,
              y:28,
              s:44
            }
          ],

          flash:{
            x:71,
            y:20,
            s:12
          }

        };

      }


      if (
        m.indexOf("pro") !== -1
      ) {

        return {

          block:{
            left:7,
            top:4,
            width:40,
            aspect:1,
            radius:27
          },

          lenses:[

            {
              x:14,
              y:12,
              s:31
            },

            {
              x:54,
              y:27,
              s:31
            },

            {
              x:17,
              y:58,
              s:31
            }

          ],

          flash:{
            x:73,
            y:10,
            s:11
          },

          sensor:{
            x:71,
            y:67,
            s:10
          }

        };

      }


      return {

        block:{
          left:7,
          top:4,
          width:36,
          aspect:1,
          radius:28
        },

        lenses:[

          {
            x:13,
            y:13,
            s:35
          },

          {
            x:52,
            y:50,
            s:35
          }

        ],

        flash:{
          x:67,
          y:13,
          s:12
        }

      };

    }


    /* SAMSUNG */

    if (
      b.indexOf("samsung") !== -1
    ) {


      if (
        m.indexOf("ultra") !== -1
      ) {

        return {

          block:{
            left:8,
            top:4,
            width:40,
            aspect:.48,
            radius:0,
            transparent:true
          },

          lenses:[

            {
              x:8,
              y:2,
              s:28
            },

            {
              x:8,
              y:35,
              s:28
            },

            {
              x:8,
              y:68,
              s:28
            },

            {
              x:55,
              y:17,
              s:22
            }

          ],

          flash:{
            x:62,
            y:52,
            s:10
          }

        };

      }


      return {

        block:{
          left:8,
          top:4,
          width:30,
          aspect:.40,
          radius:0,
          transparent:true
        },

        lenses:[

          {
            x:12,
            y:2,
            s:38
          },

          {
            x:12,
            y:34,
            s:38
          },

          {
            x:12,
            y:66,
            s:38
          }

        ],

        flash:{
          x:68,
          y:42,
          s:12
        }

      };

    }


    /* GOOGLE PIXEL */

    if (
      b.indexOf("google") !== -1 ||
      b.indexOf("pixel") !== -1
    ) {

      return {

        block:{
          left:0,
          top:6,
          width:100,
          height:10.5,
          radius:0
        },

        lenses:[

          {
            x:18,
            y:20,
            s:27
          },

          {
            x:48,
            y:20,
            s:27
          }

        ],

        flash:{
          x:82,
          y:37,
          s:10
        }

      };

    }


    /* LARGE ROUND CAMERA */

    if (

      (
        b.indexOf("vivo") !== -1 &&
        /^x/.test(m)
      )

      ||

      (
        b.indexOf("iqoo") !== -1 &&
        /^(12|13|15)/.test(m)
      )

      ||

      (
        b.indexOf("oneplus") !== -1 &&
        /^(11|12|13|15)/.test(m)
      )

      ||

      (
        b.indexOf("oppo") !== -1 &&
        m.indexOf("find x") !== -1
      )

      ||

      (
        b.indexOf("xiaomi") !== -1 &&
        m.indexOf("ultra") !== -1
      )

    ) {

      return {

        block:{
          left:26,
          top:3.5,
          width:48,
          aspect:1,
          radius:50
        },

        lenses:[

          {
            x:18,
            y:17,
            s:27
          },

          {
            x:55,
            y:17,
            s:27
          },

          {
            x:18,
            y:55,
            s:27
          },

          {
            x:55,
            y:55,
            s:27
          }

        ],

        flash:{
          x:77,
          y:44,
          s:9
        }

      };

    }


    /* NOTHING / CMF */

    if (
      b.indexOf("nothing") !== -1 ||
      b.indexOf("cmf") !== -1
    ) {

      return {

        block:{
          left:9,
          top:5,
          width:25,
          aspect:.56,
          radius:38,
          transparent:true
        },

        lenses:[

          {
            x:15,
            y:6,
            s:50
          },

          {
            x:15,
            y:53,
            s:50
          }

        ],

        flash:{
          x:72,
          y:42,
          s:10
        }

      };

    }


    /* GENERIC ANDROID */

    return {

      block:{
        left:7,
        top:4,
        width:38,
        aspect:.68,
        radius:24
      },

      lenses:[

        {
          x:13,
          y:10,
          s:34
        },

        {
          x:53,
          y:10,
          s:34
        },

        {
          x:13,
          y:52,
          s:34
        }

      ],

      flash:{
        x:68,
        y:61,
        s:10
      }

    };

  }


  /* =====================================================
     BUILD GENERATED CAMERA
  ===================================================== */

  function buildOverlay(desc) {

    var overlay =
      document.createElement(
        "div"
      );


    overlay.className =
      "qe-camera-overlay";


    var block =
      document.createElement(
        "div"
      );


    block.className =
      "qe-camera-block" +
      (
        desc.block.transparent
          ? " qe-transparent"
          : ""
      );


    block.style.left =
      desc.block.left + "%";


    block.style.top =
      desc.block.top + "%";


    block.style.width =
      desc.block.width + "%";


    if (
      desc.block.height != null
    ) {

      block.style.height =
        desc.block.height + "%";

    }

    else {

      block.style.aspectRatio =
        String(
          desc.block.aspect || 1
        );

    }


    block.style.borderRadius =
      (
        desc.block.radius || 0
      ) +
      "%";


    (
      desc.lenses || []
    ).forEach(
      function(lens){

        var el =
          document.createElement(
            "span"
          );


        el.className =
          "qe-lens";


        el.style.left =
          lens.x + "%";


        el.style.top =
          lens.y + "%";


        el.style.width =
          lens.s + "%";


        el.style.aspectRatio =
          "1";


        block.appendChild(
          el
        );

      }
    );


    if (
      desc.flash
    ) {

      var flash =
        document.createElement(
          "span"
        );


      flash.className =
        "qe-flash";


      flash.style.left =
        desc.flash.x + "%";


      flash.style.top =
        desc.flash.y + "%";


      flash.style.width =
        desc.flash.s + "%";


      flash.style.aspectRatio =
        "1";


      block.appendChild(
        flash
      );

    }


    if (
      desc.sensor
    ) {

      var sensor =
        document.createElement(
          "span"
        );


      sensor.className =
        "qe-sensor";


      sensor.style.left =
        desc.sensor.x + "%";


      sensor.style.top =
        desc.sensor.y + "%";


      sensor.style.width =
        desc.sensor.s + "%";


      sensor.style.aspectRatio =
        "1";


      block.appendChild(
        sensor
      );

    }


    overlay.appendChild(
      block
    );


    return overlay;

  }


  function removeGenerated(host) {

    if (!host) return;


    host
      .querySelectorAll(
        ".qe-camera-overlay"
      )
      .forEach(
        function(el){

          el.remove();

        }
      );

  }


  /* =====================================================
     RESET AI PREVIEW
  ===================================================== */

  function resetAI(
    phone,
    template,
    cutout,
    art,
    camera
  ) {

    if (!phone) return;


    phone.classList.remove(
      "has-real-template",
      "qe-r2-template",
      "qe-r2-standard",
      "qe-r2-fold",
      "qe-r2-flip"
    );


    phone.removeAttribute(
      "data-template-key"
    );


    phone.removeAttribute(
      "data-template-url"
    );


    phone.removeAttribute(
      "data-template-source"
    );


    phone.removeAttribute(
      "data-template-request"
    );


    removeGenerated(
      phone
    );


    if (
      template
    ) {

      template.onload =
        null;


      template.onerror =
        null;


      template.style.display =
        "none";


      template.removeAttribute(
        "src"
      );


      template.alt =
        "";

    }


    if (
      cutout
    ) {

      cutout.style.setProperty(
        "display",
        "none",
        "important"
      );


      [
        "left",
        "top",
        "width",
        "height",
        "border-radius"
      ].forEach(
        function(prop){

          cutout.style.removeProperty(
            prop
          );

        }
      );

    }


    if (
      art
    ) {

      art.style.removeProperty(
        "clip-path"
      );


      art.style.removeProperty(
        "-webkit-clip-path"
      );

    }


    if (
      camera
    ) {

      camera.style.removeProperty(
        "display"
      );


      camera.style.removeProperty(
        "visibility"
      );


      camera.style.removeProperty(
        "opacity"
      );

    }


    window.QUEED_CURRENT_TEMPLATE_URL =
      "";


    window.QUEED_CURRENT_TEMPLATE_SOURCE =
      "";

  }


  function hideOldCamera(
    camera
  ) {

    if (!camera) return;


    camera.style.setProperty(
      "display",
      "none",
      "important"
    );


    camera.style.setProperty(
      "visibility",
      "hidden",
      "important"
    );


    camera.style.setProperty(
      "opacity",
      "0",
      "important"
    );

  }


  /* =====================================================
     GENERATED FALLBACK
  ===================================================== */

  function applyFallback(
    phone,
    camera,
    brand,
    model
  ) {

    removeGenerated(
      phone
    );


    hideOldCamera(
      camera
    );


    phone.appendChild(
      buildOverlay(
        descFor(
          brand,
          model
        )
      )
    );

  }


  /* =====================================================
     EXACT AI TEMPLATE
  ===================================================== */

  function applyExactAI(
    phone,
    template,
    cutout,
    art,
    camera,
    brand,
    model,
    exact
  ) {

    removeGenerated(
      phone
    );


    phone.classList.remove(
      "qe-r2-template",
      "qe-r2-standard",
      "qe-r2-fold",
      "qe-r2-flip"
    );


    phone.classList.add(
      "has-real-template"
    );


    phone.setAttribute(
      "data-template-key",

      exact.templateKey ||

      (
        slug(brand) +
        "-" +
        slug(model)
      )
    );


    phone.setAttribute(
      "data-template-url",
      exact.template
    );


    phone.setAttribute(
      "data-template-source",
      "exact"
    );


    phone.setAttribute(
      "data-template-request",
      key(
        brand,
        model
      )
    );


    if (
      template
    ) {

      template.onload =
        null;


      template.onerror =
        null;


      template.src =
        exact.template;


      template.alt =
        brand +
        " " +
        model +
        " case preview template";


      template.style.setProperty(
        "display",
        "block",
        "important"
      );

    }


    if (
      art &&
      exact.aiCrop
    ) {

      art.style.setProperty(
        "clip-path",
        exact.aiCrop,
        "important"
      );


      art.style.setProperty(
        "-webkit-clip-path",
        exact.aiCrop,
        "important"
      );

    }


    if (
      cutout &&
      exact.aiCutout
    ) {

      cutout.style.setProperty(
        "display",
        "block",
        "important"
      );


      cutout.style.setProperty(
        "left",
        exact.aiCutout.left,
        "important"
      );


      cutout.style.setProperty(
        "top",
        exact.aiCutout.top,
        "important"
      );


      cutout.style.setProperty(
        "width",
        exact.aiCutout.width,
        "important"
      );


      cutout.style.setProperty(
        "height",
        exact.aiCutout.height,
        "important"
      );


      cutout.style.setProperty(
        "border-radius",
        exact.aiCutout.radius,
        "important"
      );

    }


    hideOldCamera(
      camera
    );


    window.QUEED_CURRENT_TEMPLATE_URL =
      exact.template;


    window.QUEED_CURRENT_TEMPLATE_SOURCE =
      "exact";


    window.QUEED_CURRENT_PHONE = {

      brand:brand,

      model:model,

      templateUrl:
        exact.template,

      templateSource:
        "exact"

    };


    try {

      localStorage.setItem(
        "queedSelectedBrand",
        brand
      );


      localStorage.setItem(
        "queedSelectedModel",
        model
      );


      localStorage.setItem(
        "queedSelectedTemplateUrl",
        exact.template
      );

    }

    catch(error){}

  }


  /* =====================================================
     R2 AI TEMPLATE
  ===================================================== */

  function applyR2AI(
    phone,
    template,
    cutout,
    art,
    camera,
    brand,
    model
  ) {

    var url =
      r2TemplateUrl(
        brand,
        model
      );


    var signature =
      key(
        brand,
        model
      );


    var family =
      familyFor(
        brand,
        model
      );


    var crop =
      cropFor(
        brand,
        model
      );


    if (
      !url ||
      !template
    ) {

      resetAI(
        phone,
        template,
        cutout,
        art,
        camera
      );


      applyFallback(
        phone,
        camera,
        brand,
        model
      );


      return;

    }


    removeGenerated(
      phone
    );


    phone.classList.remove(
      "qe-r2-standard",
      "qe-r2-fold",
      "qe-r2-flip"
    );


    phone.classList.add(
      "has-real-template",
      "qe-r2-template",
      "qe-r2-" + family
    );


    phone.setAttribute(
      "data-template-key",

      slug(brand) +
      "-" +
      slug(model)
    );


    phone.setAttribute(
      "data-template-url",
      url
    );


    phone.setAttribute(
      "data-template-source",
      "r2"
    );


    phone.setAttribute(
      "data-template-request",
      signature
    );


    hideOldCamera(
      camera
    );


    if (
      cutout
    ) {

      cutout.style.setProperty(
        "display",
        "none",
        "important"
      );

    }


    if (
      art
    ) {

      art.style.setProperty(
        "clip-path",
        crop,
        "important"
      );


      art.style.setProperty(
        "-webkit-clip-path",
        crop,
        "important"
      );

    }


    template.onload =
      null;


    template.onerror =
      null;


    template.style.setProperty(
      "display",
      "none",
      "important"
    );


    template.alt =
      brand +
      " " +
      model +
      " case preview template";


    /*
      CHECK IMAGE BEFORE SHOWING
    */

    var probe =
      new Image();


    probe.onload =
      function(){


        if (
          phone.getAttribute(
            "data-template-request"
          ) !== signature
        ) {

          return;

        }


        template.src =
          url;


        template.style.setProperty(
          "display",
          "block",
          "important"
        );


        window.QUEED_CURRENT_TEMPLATE_URL =
          url;


        window.QUEED_CURRENT_TEMPLATE_SOURCE =
          "r2";


        window.QUEED_CURRENT_PHONE = {

          brand:brand,

          model:model,

          templateUrl:url,

          templateSource:"r2"

        };


        try {

          localStorage.setItem(
            "queedSelectedBrand",
            brand
          );


          localStorage.setItem(
            "queedSelectedModel",
            model
          );


          localStorage.setItem(
            "queedSelectedTemplateUrl",
            url
          );

        }

        catch(error){}

      };


    probe.onerror =
      function(){


        if (
          phone.getAttribute(
            "data-template-request"
          ) !== signature
        ) {

          return;

        }


        console.error(
          "QUEED R2 TEMPLATE NOT FOUND:",
          url
        );


        resetAI(
          phone,
          template,
          cutout,
          art,
          camera
        );


        applyFallback(
          phone,
          camera,
          brand,
          model
        );

      };


    probe.src =
      url;

  }


  /* =====================================================
     APPLY AI
  ===================================================== */

  function applyAI(root) {

    addStyles();


    root =
      root ||
      document.getElementById(
        "queed-ai-lab"
      );


    if (!root) return;


    var brandSelect =
      root.querySelector(
        "#q-brand"
      );


    var modelSelect =
      root.querySelector(
        "#q-model"
      );


    var phone =
      root.querySelector(
        "#q-phone"
      );


    var art =
      root.querySelector(
        "#q-art"
      );


    var template =
      root.querySelector(
        "#q-model-template"
      );


    var cutout =
      root.querySelector(
        "#q-model-cutout"
      );


    var camera =
      root.querySelector(
        "#q-camera"
      );


    if (
      !brandSelect ||
      !modelSelect ||
      !phone ||
      !art
    ) {

      return;

    }


    var brand =
      String(
        brandSelect.value ||
        ""
      ).trim();


    var model =
      String(
        modelSelect.value ||
        ""
      ).trim();


    if (
      !brand ||
      !model
    ) {

      resetAI(
        phone,
        template,
        cutout,
        art,
        camera
      );


      return;

    }


    var exact =
      EXACT[
        key(
          brand,
          model
        )
      ];


    if (
      exact &&
      exact.mode ===
        "exact-image"
    ) {

      applyExactAI(
        phone,
        template,
        cutout,
        art,
        camera,
        brand,
        model,
        exact
      );


      return;

    }


    applyR2AI(
      phone,
      template,
      cutout,
      art,
      camera,
      brand,
      model
    );

  }


  /* =====================================================
     BIND AI EVENTS
  ===================================================== */

  function bindAI(root) {

    root =
      root ||
      document.getElementById(
        "queed-ai-lab"
      );


    if (!root) return;


    var previousVersion =
      root.getAttribute(
        "data-qe-engine-version"
      );


    if (
      previousVersion ===
      ENGINE_VERSION
    ) {

      applyAI(
        root
      );


      return;

    }


    root.setAttribute(
      "data-qe-engine-version",
      ENGINE_VERSION
    );


    var brand =
      root.querySelector(
        "#q-brand"
      );


    var model =
      root.querySelector(
        "#q-model"
      );


    if (
      brand
    ) {

      brand.addEventListener(
        "change",
        function(){


          setTimeout(
            function(){

              applyAI(
                root
              );

            },
            120
          );

        }
      );

    }


    if (
      model
    ) {

      model.addEventListener(
        "change",
        function(){


          setTimeout(
            function(){

              applyAI(
                root
              );

            },
            20
          );

        }
      );

    }


    setTimeout(
      function(){

        applyAI(
          root
        );

      },
      150
    );


    setTimeout(
      function(){

        applyAI(
          root
        );

      },
      650
    );

  }


  /* =====================================================
     CART
  ===================================================== */

  function cleanCartCase(
    caseEl
  ) {

    if (!caseEl) return;


    caseEl.classList.remove(
      "qe-r2-cart"
    );


    caseEl
      .querySelectorAll(
        ".qe-camera-overlay," +
        ".queed-cart-model-template," +
        ".queed-cart-exact-cutout"
      )
      .forEach(
        function(el){

          el.remove();

        }
      );


    var art =
      caseEl.querySelector(
        ".queed-cart-art"
      );


    if (
      art
    ) {

      art.style.removeProperty(
        "clip-path"
      );


      art.style.removeProperty(
        "-webkit-clip-path"
      );

    }

  }


  function applyCartR2(
    caseEl,
    brand,
    model
  ) {

    var url =
      r2TemplateUrl(
        brand,
        model
      );


    var art =
      caseEl.querySelector(
        ".queed-cart-art"
      );


    var crop =
      cropFor(
        brand,
        model
      );


    if (!url) {

      caseEl.appendChild(
        buildOverlay(
          descFor(
            brand,
            model
          )
        )
      );


      return;

    }


    var probe =
      new Image();


    probe.onload =
      function(){


        cleanCartCase(
          caseEl
        );


        caseEl.classList.add(
          "qe-r2-cart"
        );


        var img =
          document.createElement(
            "img"
          );


        img.className =
          "queed-cart-model-template";


        img.src =
          url;


        img.alt =
          brand +
          " " +
          model +
          " custom case preview";


        caseEl.appendChild(
          img
        );


        if (
          art
        ) {

          art.style.setProperty(
            "clip-path",
            crop,
            "important"
          );


          art.style.setProperty(
            "-webkit-clip-path",
            crop,
            "important"
          );

        }

      };


    probe.onerror =
      function(){


        cleanCartCase(
          caseEl
        );


        caseEl.appendChild(
          buildOverlay(
            descFor(
              brand,
              model
            )
          )
        );

      };


    probe.src =
      url;

  }


  function applyCart(scope) {

    addStyles();


    scope =
      scope ||
      document;


    var cases =
      scope.querySelectorAll(
        ".queed-cart-case" +
        "[data-queed-brand]" +
        "[data-queed-model]"
      );


    cases.forEach(
      function(caseEl){


        var brand =
          caseEl.getAttribute(
            "data-queed-brand"
          ) ||
          "";


        var model =
          caseEl.getAttribute(
            "data-queed-model"
          ) ||
          "";


        var signature =
          key(
            brand,
            model
          );


        if (
          !brand ||
          !model
        ) {

          return;

        }


        if (
          caseEl.getAttribute(
            "data-qe-signature"
          ) === signature
        ) {

          return;

        }


        caseEl.setAttribute(
          "data-qe-signature",
          signature
        );


        cleanCartCase(
          caseEl
        );


        var art =
          caseEl.querySelector(
            ".queed-cart-art"
          );


        var exact =
          EXACT[
            signature
          ];


        if (
          exact &&
          exact.mode ===
            "exact-image"
        ) {


          var img =
            document.createElement(
              "img"
            );


          img.className =
            "queed-cart-model-template";


          img.src =
            exact.template;


          img.alt =
            brand +
            " " +
            model +
            " custom case preview";


          caseEl.appendChild(
            img
          );


          if (
            exact.cartCutout
          ) {


            var exactCutout =
              document.createElement(
                "span"
              );


            exactCutout.className =
              "queed-cart-exact-cutout";


            exactCutout.style.setProperty(
              "left",
              exact.cartCutout.left,
              "important"
            );


            exactCutout.style.setProperty(
              "top",
              exact.cartCutout.top,
              "important"
            );


            exactCutout.style.setProperty(
              "width",
              exact.cartCutout.width,
              "important"
            );


            exactCutout.style.setProperty(
              "height",
              exact.cartCutout.height,
              "important"
            );


            exactCutout.style.setProperty(
              "border-radius",
              exact.cartCutout.radius,
              "important"
            );


            caseEl.appendChild(
              exactCutout
            );

          }


          if (
            art &&
            exact.cartCrop
          ) {

            art.style.setProperty(
              "clip-path",
              exact.cartCrop,
              "important"
            );


            art.style.setProperty(
              "-webkit-clip-path",
              exact.cartCrop,
              "important"
            );

          }


          return;

        }


        applyCartR2(
          caseEl,
          brand,
          model
        );

      }
    );

  }


  /* =====================================================
     REGISTER FUTURE EXACT MODELS
  ===================================================== */

  function registerExact(
    brand,
    model,
    data
  ) {

    if (
      !brand ||
      !model ||
      !data
    ) {

      return;

    }


    EXACT[
      key(
        brand,
        model
      )
    ] =
      data;

  }


  function registerExactBatch(
    batch
  ) {

    if (!batch) return;


    Object
      .keys(
        batch
      )
      .forEach(
        function(brand){


          var models =
            batch[brand] ||
            {};


          Object
            .keys(
              models
            )
            .forEach(
              function(model){


                registerExact(
                  brand,
                  model,
                  models[model]
                );

              }
            );

        }
      );


    var aiRoot =
      document.getElementById(
        "queed-ai-lab"
      );


    if (
      aiRoot
    ) {

      applyAI(
        aiRoot
      );

    }


    applyCart(
      document
    );

  }


  /* =====================================================
     CART WATCHER
  ===================================================== */

  var cartTimer =
    null;


  function scheduleCartScan() {

    clearTimeout(
      cartTimer
    );


    cartTimer =
      setTimeout(
        function(){

          applyCart(
            document
          );

        },
        80
      );

  }


  /* =====================================================
     START
  ===================================================== */

  function start() {

    addStyles();


    var aiRoot =
      document.getElementById(
        "queed-ai-lab"
      );


    if (
      aiRoot
    ) {

      bindAI(
        aiRoot
      );

    }


    applyCart(
      document
    );


    if (
      document.body &&
      !window.__QUEED_CART_OBSERVER_V2__
    ) {

      window.__QUEED_CART_OBSERVER_V2__ =
        new MutationObserver(
          scheduleCartScan
        );


      window.__QUEED_CART_OBSERVER_V2__
        .observe(
          document.body,
          {

            childList:true,

            subtree:true

          }
        );

    }

  }


  /* =====================================================
     PUBLIC ENGINE
  ===================================================== */

  window.QUEED_MODEL_ENGINE = {

    version:
      ENGINE_VERSION,


    exact:
      EXACT,


    resolve:
      function(
        brand,
        model
      ){


        var exact =
          EXACT[
            key(
              brand,
              model
            )
          ];


        if (
          exact
        ) {

          return exact;

        }


        return {

          mode:
            "r2-image",

          template:
            r2TemplateUrl(
              brand,
              model
            ),

          templateKey:
            slug(brand) +
            "-" +
            slug(model),

          family:
            familyFor(
              brand,
              model
            ),

          aiCrop:
            cropFor(
              brand,
              model
            ),

          fallbackCamera:
            descFor(
              brand,
              model
            )

        };

      },


    templateUrl:
      r2TemplateUrl,


    applyAI:
      applyAI,


    bindAI:
      bindAI,


    applyCart:
      applyCart,


    registerExact:
      registerExact,


    registerExactBatch:
      registerExactBatch,


    refresh:
      function(){


        var aiRoot =
          document.getElementById(
            "queed-ai-lab"
          );


        if (
          aiRoot
        ) {

          applyAI(
            aiRoot
          );

        }


        applyCart(
          document
        );

      }

  };


  /* =====================================================
     AUTO RUN
  ===================================================== */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once:true
      }
    );

  }

  else {

    start();

  }


})(window, document);